interface LogoProps {
  className?: string;
}

export const Logo = ({ className }: LogoProps) => {
  return (
    <div className={`flex items-center ${className || ''}`}>
      <span className="text-white font-semibold text-3xl sm:text-4xl tracking-wide font-orbitron">
        Chat Bot Labs
      </span>
    </div>
  );
};
